export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@2x.5f392130.png";